"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleEnum = void 0;
var RoleEnum;
(function (RoleEnum) {
    RoleEnum[RoleEnum["Superadmin"] = 1] = "Superadmin";
    RoleEnum[RoleEnum["Admin"] = 2] = "Admin";
    RoleEnum[RoleEnum["Agent"] = 4] = "Agent";
    RoleEnum[RoleEnum["AdminAgent"] = 6] = "AdminAgent";
})(RoleEnum = exports.RoleEnum || (exports.RoleEnum = {}));
